@import url("https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..900;1,9..144,300..900&family=Geist:wght@300..900&family=JetBrains+Mono:wght@400;500;600&display=swap");
@import "@xterm/xterm/css/xterm.css";
@import "./tokens.css";
@import "./claudeflow.css";

@import "tailwindcss";

@theme {
  --color-bg: #0E0E0F;
  --color-bg-elev: #161618;
  --color-fg: #ECEAE4;
  --color-accent: #FF3B1F;
}
